import Create from './Create';
import Edit from './Edit';

export default {
  name: 'prices/package',
  create: Create,
  edit: Edit,
};
